let today = new Date()

let originalFilter = {
    keyword: '',
    startYear: null,
    endYear: today.getFullYear(),
    epaRegion: '',
    epaType: '',
    foiaSource: [],
    statute: [],
}

export default originalFilter;